module.exports = __webpack_public_path__ + "static/media/a7.74a075d7.png";